import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19bd38be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-weight-bold",
  id: "circularProgressCounter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!

  return (_openBlock(), _createBlock(_component_q_circular_progress, {
    "show-value": "",
    class: "text-light-dark",
    value: _ctx.portal.currentNavIndex,
    max: _ctx.portal.getTotalPages(),
    "track-color": "grey-3",
    size: "70px",
    color: "primary",
    thickness: 0.1,
    id: "circularProgress"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.portal.currentNavIndex) + "/" + _toDisplayString(_ctx.portal.getTotalPages()), 1)
    ]),
    _: 1
  }, 8, ["value", "max"]))
}